import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Form, Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";

/* Actions  */
import { postChangePass, resetChangePass } from "../../actions/login";

function ModalChangePass(props) {
  /*  Use  states  */
  const [form, setForm] = useState({
    pass: "",
    newpass: "",
    email: "",
  });

  /*  User Select from redux  */
  const state = useSelector((state) => state.login);
  const dispatch = useDispatch();

  const handleChange = (event) => {
    event.persist();
    setForm((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const postChange = (event) => {
    event.preventDefault();
    dispatch(
      postChangePass({
        form,
      })
    );
  };

  const closeModal = () => {
    props.setModal(false);
    dispatch(resetChangePass());
  };

  let error = "";
  if (!state.dataChangePass) {
    error = (
      <p className="text-error">
        <FormattedMessage id="ThereWasAnError" />
      </p>
    );
  }

  if (state.statusChangePass === 200) {
    if (state.dataChangePass.mensaje) {
      error = (
        <h3 className="text-success">
          <FormattedMessage id="ChangePassSuccessful" />
        </h3>
      );
    } else {
      error = (
        <p className="text-error">
          <FormattedMessage id="ThereWasAnError" />
        </p>
      );
    }
  }
  return (
    <>
      <Modal
        show={props.modal}
        onHide={closeModal}
        aria-labelledby="example-custom-modal-styling-title"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            <FormattedMessage id="ChangeMyPassword" />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="email">
            <Form.Label>
              <FormattedMessage id="Email" />
            </Form.Label>
            <FormattedMessage id="WriteYourEmail">
              {(msg) => (
                <Form.Control
                  defaultValue={form.email}
                  onChange={handleChange}
                  name={"email"}
                  autoComplete="current-password"
                  type="text"
                  placeholder={msg}
                />
              )}
            </FormattedMessage>
          </Form.Group>
          <Form.Group controlId="pass">
            <Form.Label>
              <FormattedMessage id="Password" />
            </Form.Label>
            <FormattedMessage id="WriteYourOldPass">
              {(msg) => (
                <Form.Control
                  defaultValue={form.pass}
                  onChange={handleChange}
                  name={"pass"}
                  autoComplete="current-password"
                  type="password"
                  placeholder={msg}
                />
              )}
            </FormattedMessage>
          </Form.Group>
          <Form.Group controlId="newpass">
            <Form.Label>
              <FormattedMessage id="NewPass" />
            </Form.Label>
            <FormattedMessage id="WriteYourNewPass">
              {(msg) => (
                <Form.Control
                  defaultValue={form.newpass}
                  onChange={handleChange}
                  name={"newpass"}
                  autoComplete="current-password"
                  type="password"
                  placeholder={msg}
                />
              )}
            </FormattedMessage>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          {error}
          <Button
            disabled={state.loadingChangePass}
            variant="main"
            type="submit"
            onClick={postChange}
          >
            {state.loadingChangePass ? (
              <FormattedMessage id="Loading" />
            ) : (
              <FormattedMessage id="Send" />
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalChangePass;
